import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Server, ShieldCheck, Globe, FileCode, Activity } from 'lucide-react';
const trustSignals = [{
  icon: Lock,
  title: 'AES-256 Encryption',
  description: 'Bank-grade encryption protects every byte at rest and in transit.'
}, {
  icon: ShieldCheck,
  title: 'Zero-Knowledge Architecture',
  description: 'Your master key never leaves your device. We cannot access your data — by design.'
}, {
  icon: FileCode,
  title: 'SOC 2 Type II Compliant',
  description: 'Independently audited security controls and processes.'
}, {
  icon: Globe,
  title: 'GDPR Compliant',
  description: 'Full compliance with European data protection regulations.'
}, {
  icon: Server,
  title: 'Open-Source Audited',
  description: 'Core cryptographic libraries publicly auditable for transparency.'
}, {
  icon: Activity,
  title: '99.99% Uptime SLA',
  description: 'Redundant infrastructure ensures your vault is always accessible.'
}];
export function TrustSection() {
  return <section id="trust" className="py-24 bg-[#0a0a0f] border-t border-[#1e1e2e]" data-id="element-147">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <div className="text-center mb-16" data-id="element-149">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-150">
            ENGINEERED FOR <span className="text-[#a0a0b0]" data-id="element-151">PARANOIA</span>
          </h2>
          <p className="text-[#a0a0b0] max-w-2xl mx-auto" data-id="element-152">
            We don't ask you to trust us. We build systems that don't require
            it.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-153">
          {trustSignals.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="flex flex-col items-center text-center p-6 bg-[#111118]/50 rounded-lg hover:bg-[#111118] transition-colors" data-id="element-154">
              <div className="mb-4 p-3 bg-[#00ff88]/5 rounded-full" data-id="element-155">
                <item.icon className="w-8 h-8 text-[#00ff88]" data-id="element-156" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2 font-mono" data-id="element-157">
                {item.title}
              </h3>
              <p className="text-[#a0a0b0] text-sm leading-relaxed" data-id="element-158">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}